import React, { useState, useEffect } from 'react'
import { useTranslate, useNotify, useRefresh } from 'react-admin'
import SaveIcon from '@mui/icons-material/Save'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Button,
  DialogActions,
  Select,
  MenuItem,
  TextField,
} from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import LoadingButton from '@mui/lab/LoadingButton'
import { paxServices } from 'src/services/reservation/pax/pax.service'
import { customAwait } from '../../helper/customAwait'

export const PassengerAirModal = ({ open, setOpen, pax_item_data, passenger, handleCloseEditEticketModal }) => {
  const translate = useTranslate()
  const refresh = useRefresh()
  const notify = useNotify()
  const [passengerForm, setPassengerForm] = useState({})
  const [passengerLoading, setPassengerLoading] = useState(false)

  useEffect(() => {
    if (pax_item_data) {
      setPassengerForm(pax_item_data)
    }
  }, [pax_item_data])

  const handleChangePassengerTicket = (field, value) => {
    setPassengerForm((current) => ({
      ...current,
      [field]: value,
    }))
  }

  const setClosePassengerAirModal = () => {
    setOpen(false)
    setPassengerForm({})
    handleCloseEditEticketModal()
  }

  const updateTicketAirPassenger = (passengerForm) => {
    try {
      setPassengerLoading(true)
      const pax = paxServices.updatePaxItems(passengerForm)
      if (pax) {
        notify('ra.notification.updated_success_passenger', {
          type: 'success',
          messageArgs: { passenger: `${passenger?.name} - ${passenger?.surname}` },
        })
      } else {
        notify('ra.notification.updated_error_titular', {
          type: 'error',
          messageArgs: { passenger: `${passenger?.name} - ${passenger?.surname}` },
        })
      }
    } catch (error) {
      notify('ra.notification.updated_error_titular', {
        type: 'error',
        messageArgs: { passenger: `${passenger?.name} - ${passenger?.surname}` },
      })
    } finally {
      setPassengerLoading(false)
      customAwait([refresh, () => setPassengerLoading(false)])
      setClosePassengerAirModal()
    }
  }

  return (
    <Dialog fullWidth maxWidth='sm' className='sale-invoice-modal' open={open}>
      <DialogTitle>{translate('ra.title.update_eticket')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <EditInputsWrap
            label={translate('ra.field.ticket_type')}
            required
            md={12}
            lg={12}
            style={{ minHeight: 0 }}
          >
            <Select
              fullWidth
              onChange={(e) => handleChangePassengerTicket('ticket_type', e.target.value)}
              value={passengerForm?.ticket_type || ''}
              size='small'
            >
              <MenuItem value='TKT'>TKT</MenuItem>
              <MenuItem value='EMD'>EMD</MenuItem>
              <MenuItem value='REM'>REM </MenuItem>
            </Select>
          </EditInputsWrap>

          <EditInputsWrap
            label={translate('ra.field.ticket_number')}
            md={12}
            lg={12}
            style={{ minHeight: 0 }}
          >
            <TextField
              value={passengerForm?.ticket_number || ''}
              onChange={(e) => handleChangePassengerTicket('ticket_number', e.target.value)}
              size='small'
              sx={{ width: { xs: '100%', sm: '50%' } }}
            />
          </EditInputsWrap>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={() => setClosePassengerAirModal()}>
          {translate('ra.action.cancel')}
        </Button>
        <LoadingButton
          loading={passengerLoading}
          size='small'
          variant='contained'
          startIcon={<SaveIcon />}
          onClick={() => updateTicketAirPassenger(passengerForm)}
        >
          {translate('ra.action.save')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
